var _rect, _rect2, _rect3, _rect4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigAdditionalColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 67,
    viewBox: "0 0 76 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.1406,
    y: 19.4033,
    width: 29.4956,
    height: 56.4809,
    rx: 2,
    transform: "rotate(70.4723 66.1406 19.4033)",
    fill: "#EFE863"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.1162,
    y: 6.2998,
    width: 29.4956,
    height: 56.4809,
    rx: 2,
    transform: "rotate(49.5785 50.1162 6.2998)",
    fill: "#E79148"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.4893,
    width: 29.4956,
    height: 58.9912,
    rx: 2,
    transform: "rotate(30.7817 31.4893 0)",
    fill: "#843387"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 3.1377,
    width: 29.4956,
    height: 62.7566,
    rx: 2,
    fill: "#52B3A7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.0441,
    cy: 61.8146,
    r: 2.19648,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigAdditionalColor);
export default __webpack_public_path__ + "static/media/jobconfig-additional-color.f8a8ff57fc3916f8349cf68b467efd32.svg";
export { ForwardRef as ReactComponent };